import React from 'react';
import { Container, Box, CardContent } from '@mui/material';
import {
    ActionsWrapper,
    IconCircle,
    IconWrapper,
    Paragraph,
    Title,
} from '../../pages/auth/styled';
import LockPersonIcon from '@mui/icons-material/LockPerson';
import { useNavigate } from 'react-router-dom';
import ButtonGeneral from '../general/buttons/buttonGeneral';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

type Props = {
    validate?: any;
};

const BlockPagesDefault = ({ validate }: Props) => {
    const navigate = useNavigate();

    return (
        <Box id="Página Bloqueada">
            <Container maxWidth="md" style={{ marginTop: 20 }}>
                <Box mt={8}>
                    <CardContent>
                        <IconWrapper>
                            <IconCircle>
                                <LockPersonIcon
                                    style={{
                                        fontSize: '5rem',
                                        color: 'white',
                                    }}
                                />
                            </IconCircle>
                        </IconWrapper>
                        <Title variant="h4">{validate?.page}</Title>
                        <Paragraph>{validate?.description}</Paragraph>
                        <ActionsWrapper>
                            <ButtonGeneral
                                onClick={() => navigate(-1)}
                                startIcon={<ArrowBackIcon color="secondary" />}
                                title="Atrás"
                            />
                        </ActionsWrapper>
                    </CardContent>
                </Box>
            </Container>
        </Box>
    );
};

export default BlockPagesDefault;
